import script from "./NearMissList.vue?vue&type=script&lang=ts&setup=true"
export * from "./NearMissList.vue?vue&type=script&lang=ts&setup=true"

import "./NearMissList.vue?vue&type=style&index=0&id=68b400c1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b400c1"]])

export default __exports__